import React from "react";
import { formatDictionaryToggleCount } from "./dictionaryCountFormat";

type ToggleValue = "known" | "learning";

interface KnownLearningToggleProps {
  value: ToggleValue;
  onChange: (value: ToggleValue) => void;
  knownCount: number;
  learningCount: number;
  className?: string;
}

const KnownLearningToggle: React.FC<KnownLearningToggleProps> = ({
  value,
  onChange,
  knownCount,
  learningCount,
  className = "",
}) => {
  const nonSelectedGray = "bg-[var(--color-grey-lightest)]";
  return (
    <div
      className={`relative p-[4px] rounded-full w-full font-semibold text-base z-0 ${className} ${nonSelectedGray}`}
    >
      {/* Background highlight */}
      <div
        className={`absolute transition-all duration-200 ease-in-out rounded-full shadow-[0_1px_2px_rgba(0,0,0,0.1)]`}
        style={{
          top: "4px",
          bottom: "4px",
          width: "calc(50% - 4px)",
          left: value === "learning" ? "4px" : "50%",
          backgroundColor: "var(--color-grey-other)",
        }}
      />

      {/* Buttons */}
      <div className="relative flex w-full">
        <button
          onClick={() => onChange("learning")}
          className={`
          flex-1 py-[8px] px-2 text-base transition-colors duration-200 whitespace-nowrap text-center
          ${value === "learning" ? "text-white" : "text-[var(--color-grey)]"}
          relative z-10
        `}
        >
          Learning ({formatDictionaryToggleCount(learningCount)})
        </button>
        <button
          onClick={() => onChange("known")}
          className={`
          flex-1 py-[8px] px-2 text-base transition-colors duration-200 whitespace-nowrap text-center
          ${value === "known" ? "text-white" : "text-[var(--color-grey)]"}
          relative z-10
        `}
        >
          Known ({formatDictionaryToggleCount(knownCount)})
        </button>
      </div>
    </div>
  );
};

export default KnownLearningToggle;
